var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationMessenger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "26px",
    viewBox: "0 0 18.0 26.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.0 -581.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.0 461.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 121.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01138336,0 C12.3972686,0 16.0227667,3.24510844 16.0227667,7.90240906 C16.0227667,9.58898741 15.5445257,11.3931331 14.7709881,12.7499469 L8.5306397,23.6980868 C8.42609847,23.8843841 8.22725227,24 8.01138336,24 C7.79551446,24 7.59666825,23.8843841 7.49212703,23.6980868 L1.25177865,12.7499469 C0.478270686,11.3931916 0,9.58898741 0,7.90240906 C0,3.24510844 3.62549814,0 8.01138336,0 Z M8.01138336,4.09754393 C5.88805819,4.09754393 4.15405063,5.80800508 4.15405063,7.90240906 C4.15405063,9.99683937 5.88806411,11.7072683 8.01138336,11.7072683 C10.1347026,11.7072683 11.8687161,9.99683937 11.8687161,7.90240906 C11.8687161,5.80800508 10.1347085,4.09754393 8.01138336,4.09754393 Z",
    stroke: "#000",
    strokeWidth: 1,
    fill: "none",
    strokeMiterlimit: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationMessenger);
export default __webpack_public_path__ + "static/media/icLocationMessenger.860a6fa9f897347112d4189362c5718f.svg";
export { ForwardRef as ReactComponent };